"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
//
// Definition of user tags component
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTagsComponentParameters = void 0;
exports.UserTagsComponentParameters = [
    {
        id: 'type',
        label: 'Tag Input Type',
        description: 'Input Param - Type of the keyboard to be shown (TEXT, INTEGER, FLOAT)',
        type: 'enum',
        list: {
            TEXT: 'Full keyboard with numbers, alphabets, special characters, etc',
            INTEGER: 'KB only with Integers, (0-9)',
            FLOAT: 'KB only with Integers (0-9) and Decimal (.)',
        },
        paramType: 'ENUM',
        required: true,
    },
    {
        id: 'min',
        label: 'Min Selected Tags',
        description: 'Input Param - Minimum number of tags that must be selected by the user',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'max',
        label: 'Max Selected Tags',
        description: 'Input Param - Maximum number of tags that can be selected by the user',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'options',
        label: 'Tag Options',
        description: 'Input Param - List of available tag options that the user can select from',
        type: 'list',
        paramType: 'STRING_ARRAY',
        required: false,
    },
    {
        id: 'selected',
        label: 'Tags Selected By User',
        description: 'Output Param - List of tags selected by the user',
        type: 'output',
        paramType: 'STRING_ARRAY',
        required: true,
    },
];
//# sourceMappingURL=UserTagsComponent.js.map